/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import axios, { AxiosError } from 'axios';

import { LOGIN_PATH } from '../data/constant/path';
import { getAuth, getIdToken } from 'firebase/auth';

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptors
// Add a request interceptor
axiosClient.interceptors.request.use(
  async function (config) {
    // Do something before request is sent
    const auth = getAuth();
      const user = auth.currentUser;
      if (user) {
        const token = await getIdToken(user); // Fetch the latest Firebase token
        console.log("🔑 Firebase Token being sent:", token);
   
    
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
axiosClient.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
  },
  function (error: AxiosError) {
    // Treat 423 as success for lockUnlockResponse
    if (error.response?.status === 423 && error.config?.url?.includes('LockUnlockResponse')) {
      return error.response.data; // Return {"message":"Request is now locked..."}
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response?.status === 401) {
      // clear token ...
      localStorage.removeItem('token');
      window.location.replace(LOGIN_PATH);
    }

    return Promise.reject(error);
  },
);

export default axiosClient;
